import { BlueprintInstanceType } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { isSwappableAppliance } from '../helpers/is-swappable-appliance';

export const appliancePropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Appliance Properties',
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('appliance', context.id);
		},
		isVisible: ({ refMap }): boolean => {
			// Don't continue if we are not dealing with a PanelItem
			if (refMap?.type !== BlueprintInstanceType.PanelItem) return false;

			return isSwappableAppliance(refMap.panelItem);
		}
	};
};
